import { render, staticRenderFns } from "./DialogConfirmationUser.vue?vue&type=template&id=13352422"
import script from "./DialogConfirmationUser.vue?vue&type=script&lang=js"
export * from "./DialogConfirmationUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports